package one.healthium.onboarding.domain.configs

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import one.healthium.domain.common.LoseWeightRange

@Serializable
@SerialName("input_target_weight")
data class TargetWeightInputScreenConfig(
    @SerialName("title") val title: String?,
    @SerialName("cta_title") val ctaTitle: String? = null,
    @SerialName("min_weight_kg") val minWeightKg: Int = 0,
    @SerialName("max_weight_kg") val maxWeightKg: Int = Int.MAX_VALUE,
    @SerialName("min_weight_lb") val minWeightLb: Int = 0,
    @SerialName("max_weight_lb") val maxWeightLb: Int = Int.MAX_VALUE,
    @SerialName("default_hint") val defaultHint: String? = null,
    @SerialName("wrong_weight_hint") val wrongWeightHint: String? = null,
    @SerialName("1-5%_loss_title") val upTo5LossTitle: String? = null,
    @SerialName("1-5%_loss_text") val upTo5LossText: String? = null,
    @SerialName("6-9%_loss_title") val upTo9LossTitle: String? = null,
    @SerialName("6-9%_loss_text") val upTo9LossText: String? = null,
    @SerialName("10-20%_loss_title") val upTo20LossTitle: String? = null,
    @SerialName("10-20%_loss_text") val upTo20LossText: String? = null,
    @SerialName("21-38%_loss_title") val upTo38LossTitle: String? = null,
    @SerialName("21-38%_loss_text") val upTo38LossText: String? = null,
    @SerialName("39+%_loss_title") val more39LossTitle: String? = null,
    @SerialName("39+%_loss_text") val more39LossText: String? = null,
) : ScreenConfig {
    val lossTitle = mapOf(
        LoseWeightRange.GetMoving to upTo5LossTitle,
        LoseWeightRange.Realistic to upTo9LossTitle,
        LoseWeightRange.HealthBenefits to upTo20LossTitle,
        LoseWeightRange.WorthIt to upTo38LossTitle,
        LoseWeightRange.LowWeightAlert to more39LossTitle,
    )

    val lossText = mapOf(
        LoseWeightRange.GetMoving to upTo5LossText,
        LoseWeightRange.Realistic to upTo9LossText,
        LoseWeightRange.HealthBenefits to upTo20LossText,
        LoseWeightRange.WorthIt to upTo38LossText,
        LoseWeightRange.LowWeightAlert to more39LossText,
    )
}